// removed by extract-text-webpack-plugin
module.exports = {"line1":"ActivationHeader__line1___1SJTM","line2":"ActivationHeader__line2___3pErX","warning":"ActivationHeader__warning___1HeBY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/ActivationHeader.less
 ** module id = 751
 ** module chunks = 0
 **/